import { FC, memo } from 'react'

import { Icon, IconName, IconSize } from 'ui/components'

import { CircularProgress } from '../../CircularProgress'
import { LoginButtonProps } from './LoginButtonProps'

import * as SC from './styles'

export const LoginButton: FC<LoginButtonProps> = memo((props) => {
  const { children, loading, 'data-qa': dataQA, ...rest } = props

  const data_qa = typeof children === 'string' && !dataQA ? children : dataQA

  return (
    <>
      {loading ? (
        <SC.BoxLoading disabled data-qa={data_qa} {...rest}>
          <SC.Inner>
            {children} <CircularProgress size={24} />
          </SC.Inner>
        </SC.BoxLoading>
      ) : (
        <SC.Box data-qa={data_qa} {...rest}>
          <SC.Inner>
            {children} <Icon size={IconSize.L} name={IconName.ARROW_NEXT} />
          </SC.Inner>
        </SC.Box>
      )}
    </>
  )
})
